import { useState } from "react";
import { Home, ClipboardList, Bell, User } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./SideMenu.css";

export default function EmployeeSideMenu() {
  const [active, setActive] = useState("home");
  const navigate = useNavigate();

  const menuItems = [
    {
      id: "home",
      icon: <Home size={22} className="empsm_icon_x1" />,
      label: "Dashboard",
      path: "/employee",
    },
    {
      id: "tasks",
      icon: <ClipboardList size={22} className="empsm_icon_x1" />,
      label: "My Tasks",
      path: "/employee/tasks-calendar",
    },
    {
      id: "notifications",
      icon: <Bell size={22} className="empsm_icon_x1" />,
      label: "Notifications",
      path: "/employee/notifications",
    },
    {
      id: "account",
      icon: <User size={22} className="empsm_icon_x1" />,
      label: "Account",
      path: "/employee/completed-tasks",
    },
  ];

  const handleClick = (item) => {
    setActive(item.id);
    navigate(item.path);
  };

  return (
    <div className="empsm_side_menu_x1">
      {menuItems.map((item) => (
        <motion.button
          type="button"
          key={item.id}
          onClick={() => handleClick(item)}
          className={`empsm_button_x1 ${active === item.id ? "empsm_button_active_x1" : ""}`}
          aria-label={item.label}
        >
          {item.icon}
          {active === item.id && (
            <motion.span
              layoutId="empsm_activeIndicator_x1"
              className="empsm_active_indicator_x1"
              transition={{ type: "spring", stiffness: 300, damping: 25 }}
            />
          )}
        </motion.button>
      ))}
    </div>
  );
}
